import { getIn, useFormikContext } from 'formik';
import { useEffect } from 'react';
import { LoginRegistrationFormState } from './LoginRegistrationForm';
export function EmailLoginRegistrationChangeHandler({ emailFieldKey = 'email', formState, setFormState, }) {
    const { values } = useFormikContext();
    const emailValue = getIn(values, emailFieldKey);
    useEffect(() => {
        if (formState === LoginRegistrationFormState.REGISTER) {
            return;
        }
        setFormState(LoginRegistrationFormState.REGISTER);
    }, [emailValue]);
    return null;
}
